import React from 'react';
import LogoImage from '../Header/nfib-logo.png';
import styles from './styles.css';

/** Minimal account/onboarding header (logo + nfib.com). */
export default function OnboardingAccountHeader() {
  return (
    <nav
      className={styles.container}
      data-qa-node="nav"
      data-qa-file="OnboardingAccountHeader"
    >
      <a
        href="http://www.nfib.com/"
        data-qa-node="a"
        data-qa-file="OnboardingAccountHeader"
      >
        <img
          src={LogoImage}
          className={styles.logo}
          alt="NFIB Logo"
          data-qa-node="img"
          data-qa-file="OnboardingAccountHeader"
        />
      </a>
    </nav>
  );
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/OnboardingAccountHeader/index.js